@if (newAccount.registrationFinished) {
  <app-new-account-mobile-finished-state></app-new-account-mobile-finished-state>
}

@if (!newAccount.registrationFinished && !newAccount.selfRegisterActive) {
  <app-new-account-mobile-inactive-state></app-new-account-mobile-inactive-state>
}

@if (!newAccount.registrationFinished && newAccount.selfRegisterActive) {
  <app-new-account-mobile-form-state></app-new-account-mobile-form-state>
}
